<template>
  <div class="row">
      <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
        <div class="card mb-25 border-0 rounded-0">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
              <h4 class="position-relative text-black fw-bold mb-10">Détails des contrats</h4>
              <router-link to="/liste-contrats" 
              class=" btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow  lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour</router-link>
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td>Référence :</td>
                  <td>{{ contrat?.reference }}</td>
                </tr>
                <tr>
                  <td>Place:</td>
                  <td>{{ contrat?.place?.code}}</td>
                </tr>
                <tr>
                  <td>Marchand :</td>
                  <td>{{ contrat?.usager?.nom +' '+ contrat?.usager?.prenom}}</td>
                </tr>
                <tr>
                  <td>Date mise en service :</td>
                  <td>{{ contrat?.dateMiseEnService }}</td>
                </tr>
                <tr>
                  <td>Loyer :</td>
                  <td>{{ contrat?.loyer }}</td>
                </tr>
                <tr>
                  <td>Montant :</td>
                  <td>{{ contrat?.montantContrat }}</td>
                </tr>
                <tr>
                  <td>Observation :</td>
                  <td>{{ contrat?.observation }}</td>
                </tr>
              </tbody>
            </table>
            
            <h5 class="mt-4">Éléments Électriques</h5>
            <table class="table">
              <thead>
                <tr>
                  <th>Désignation</th>
                  <th>Quantité</th>
                  <th>Prix</th>
                  <th>Montant</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="element in contrat?.contratElements" :key="element.id">
                  <td>{{ element.element.designation }}</td>
                  <td>{{ element.quantite }}</td>
                  <td>{{ element.prix }}</td>
                  <td>{{ element.montant }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { Contrat } from "@/models/Contrat";
import { error, format_date } from "@/utils/utils";
import { useRoute } from "vue-router";

export default defineComponent({
name: "ViewContrat",
setup: () => {
  const route = useRoute();
  const contrat = ref<Contrat | null>(null);

  function getContrat(id: string) {
    return ApiService.get("/contrats", id)
      .then(({ data }) => {
        contrat.value = data.data; 
      })
      .catch(({ response }) => {
        error(response.data.message);
      });
  } 

  onMounted(() => {
    const id = route.params.id as string;
    getContrat(id);
  });

  return { 
    contrat,
    getContrat,
    format_date,
  };
},
});
</script>
